<template>
    <div>
        <div class="form-item">
            <span class="label">*上传图片:</span>
            <el-upload
                :headers="headers"
                :show-file-list="false"
                :action="`${baseURL}/v1/app/UploadFile`"
                list-type="picture-card"
                :on-preview="handleImagePreview"
                :on-remove="handleImageRemove"
                :on-success="imageSuccess"
                :limit="1"
                accept="image/png,image/jpeg,image/gif,image/jpg"
            >
                <img v-if="carouseInfo.image" class="show-img" :src="imgDomain + carouseInfo.image" />
                <i v-else class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">建议尺寸为1920*580</div>
            </el-upload>
        </div>

        <div class="form-item">
            <span class="label">*展示位置:</span>
            <el-select v-model="carouseInfo.show_type" style="width:300px">
                <el-option label="首页" value="1"></el-option>
                <el-option label="产品主页" value="2"></el-option>
                <el-option label="关于我们" value="4"></el-option>
                <el-option label="用户画像" value="5"></el-option>
                <el-option label="数字营销" value="7"></el-option>
                <el-option label="经营分析" value="8"></el-option>
                <el-option label="定制化&私有化" value="9"></el-option>
                <el-option label="案例主页" value="10"></el-option>
                <el-option label="解决方案-康养行业解决方案" value="12"></el-option>
            </el-select>
        </div>
        <div class="form-item">
            <span class="label">*排序:</span>
            <el-input-number v-model="carouseInfo.sort" :min="1" style="width:300px" />
        </div>

        <div class="form-item">
            <span class="label">*跳转URL</span>
            <el-input v-model="carouseInfo.banner_url" clearable style="width: 300px" class="name-input" placeholder="请输入banner跳转URL" />
        </div>

        <div class="form-item">
            <span class="label">自定义ALT</span>
            <el-input v-model="carouseInfo.alt" clearable style="width: 300px" class="name-input" placeholder="请输入自定义ALT" />
        </div>

        <div class="form-item">
            <span class="label">*icon图标</span>
            <el-upload
                :headers="headers"
                :show-file-list="false"
                :action="`${baseURL}/v1/app/UploadFile`"
                list-type="picture-card"
                :on-preview="handleImagePreview"
                :on-remove="handleIconRemove"
                :on-success="iconSuccess"
                :limit="1"
                accept="image/png,image/jpeg,image/gif,image/jpg"
            >
                <img v-if="carouseInfo.icon_image" class="show-img" :src="imgDomain + carouseInfo.icon_image" />
                <i v-if="!carouseInfo.icon_image" class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">建议尺寸为240*50</div>
            </el-upload>
        </div>

        <div class="form-item">
            <span class="label">*icon跳转</span>
            <el-select v-model="carouseInfo.jump_type" class="icon_type" style="width: 300px;">
                <el-option label="自定义URL" value="1"></el-option>
                <el-option label="表单" value="2"></el-option>
            </el-select>
            <!-- <el-input v-if="carouseInfo.jump_type == 2" v-model="carouseInfo.jump_url" clearable style="width: 300px" class="name-input" placeholder="请输入自定义URL" /> -->
        </div>

        <div v-if="carouseInfo.jump_type == 1" class="form-item">
            <span class="label">跳转URL</span>
            <el-input v-model="carouseInfo.jump_url" clearable style="width: 300px" class="name-input" placeholder="请输入icon跳转URL" />
        </div>

        <div class="form-item">
            <span class="label">*H5banner图</span>
            <el-upload
                :headers="headers"
                :show-file-list="false"
                :action="`${baseURL}/v1/app/UploadFile`"
                list-type="picture-card"
                :on-preview="handleImagePreview"
                :on-remove="handleWebRemove"
                :on-success="webSuccess"
                :limit="1"
                accept="image/png,image/jpeg,image/gif,image/jpg"
            >
                <img v-if="carouseInfo.h5_image" class="show-img" :src="imgDomain + carouseInfo.h5_image" />
                <i v-if="!carouseInfo.h5_image" class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">建议尺寸为375*550</div>
            </el-upload>
        </div>

        <div class="form-item">
            <span class="label">*H5 icon</span>
            <el-upload
                :headers="headers"
                :show-file-list="false"
                :action="`${baseURL}/v1/app/UploadFile`"
                list-type="picture-card"
                :on-preview="handleImagePreview"
                :on-remove="handleWebIconRemove"
                :on-success="webIconSuccess"
                :limit="1"
                accept="image/png,image/jpeg,image/gif,image/jpg"
            >
                <img v-if="carouseInfo.h5_icon_image" class="show-img" :src="imgDomain + carouseInfo.h5_icon_image" />
                <i v-if="!carouseInfo.h5_icon_image" class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">建议尺寸为134*40</div>
            </el-upload>
        </div>

        <el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
        <div class="form-item">
            <el-button type="primary" :loading="loading" @click="onSaveClick">确定</el-button>
            <el-button type="primary" :loading="loading" plain @click="back">取消</el-button>
        </div>
    </div>
</template>
<script>
import { saveScroll, getScrollDetail, editScroll } from '@/api/content';
import baseURL from '../../configs/baseUrl';
import utils from '@/jslibs/utils';
import { imgDomain } from '../../configs/env';
export default {
    data() {
        return {
            imgDomain,
            dialogImageUrl: '',
            dialogVisible: false,
            headers: {
                'X-Access-Token': utils.getCookie('X-Access-Token') || ''
            },
            baseURL,
            loading: false,
            fileList: [],
            carouseInfo: {
                image: "",
                show_type: "1",
                sort: "",
                banner_url: "",
                jump_url: "",
                jump_type: "2",
                alt: "",
                icon_image: "",
                h5_image: "",
                h5_icon_image: ""
            }
        };
    },
    mounted() {
        const { uuid } = this.$route.query;
        this.uuid = uuid;
        if (this.uuid) {
            this.getScrollDetail(this.uuid)
        }
    },

    methods: {
        async getScrollDetail(uuid) {
            const res = await getScrollDetail(uuid);
            this.carouseInfo = res;
            this.carouseInfo.show_type = String(this.carouseInfo.show_type);
            this.carouseInfo.jump_type = String(this.carouseInfo.jump_type);
        },

        handleImagePreview(file) {
            if (file.url) {
                this.dialogImageUrl = file.url;
            }
            this.dialogVisible = true;
        },

        handleImageRemove(file) {
            if (file.response && file.response.result) {
                this.carouseInfo.image = '';
            } else if (file.url) {
                this.carouseInfo.image = '';
            }
        },

        imageSuccess(res, e) {
            this.carouseInfo.image = res.result;
        },

        handleIconRemove(file) {
            if (file.response && file.response.result) {
                this.carouseInfo.icon_image = '';
            } else if (file.url) {
                this.carouseInfo.icon_image = '';
            }
        },

        iconSuccess(res, e) {
            this.carouseInfo.icon_image = res.result;
        },

        handleWebIconRemove(file) {
            if (file.response && file.response.result) {
                this.carouseInfo.h5_icon_image = '';
            } else if (file.url) {
                this.carouseInfo.h5_icon_image = '';
            }
        },

        webIconSuccess(res, e) {
            this.carouseInfo.h5_icon_image = res.result;
        },

        handleWebRemove(file) {
            if (file.response && file.response.result) {
                this.carouseInfo.h5_image = '';
            } else if (file.url) {
                this.carouseInfo.h5_image = '';
            }
        },

        webSuccess(res, e) {
            this.carouseInfo.h5_image = res.result;
        },

        async onSaveClick() {
            const { image, show_type, sort, banner_url, alt, icon_image, jump_type, jump_url, h5_icon_image, h5_image } = this.carouseInfo;
            if (!image) {
                return this.$notify.error({ title: '请上传图片' });
            }
            if (!show_type) return this.$notify.error({ title: '请选择展示位置' });
            if (!sort) return this.$notify.error({ title: '请选择排序' });
            if (!banner_url) return this.$notify.error({ title: '请banner跳转链接' });
            if (!icon_image) return this.$notify.error({ title: '请上传icon图标' });
            if (!jump_type) return this.$notify.error({ title: '请选择icon跳转类型' });
            if (jump_type == "1" && !jump_url) return this.$notify.error({ title: '请输入跳转链接' });
            if (!h5_image) {
                return this.$notify.error({ title: '请上传H5banner图' });
            }
            if (!h5_icon_image) {
                return this.$notify.error({ title: '请上传H5 icon图' });
            }
            this.onSubmitClick()
        },

        async onSubmitClick() {
            if (this.uuid) {
                const res = await editScroll(this.uuid, this.carouseInfo);
                if (res == true) {
                    this.$notify.success({ title: '编辑轮播图成功' });
                }
            } else {
                const res = await saveScroll(this.carouseInfo);
                if (res == true) {
                    this.$notify.success({ title: '新增成功' });
                }
            }
            this.$router.push({
                name: '/carousel-list'
            });
        },

        back() {
            sessionStorage.removeItem("page_index")
            this.$router.back()
        }
    }
};
</script>
<style lang="less" scoped>
.form-item {
    display: flex;
    align-items: center;
    margin: 20px;
    .icon_type{
        margin-right: 20px;
    }
}
.label {
    display: inline-block;
    width: 180px;
    flex-shrink: 0;
}
.show-img{
    width: 148px;
    height: 148px;
}
.el-upload__tip{
    color: red;
}
</style>
